import { render } from "./payer.vue?vue&type=template&id=0dc4e7a6"
import script from "./payer.vue?vue&type=script&lang=js"
export * from "./payer.vue?vue&type=script&lang=js"

import "./payer.vue?vue&type=style&index=0&id=0dc4e7a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__